<template>
  <div class="region-profile-card pb-5" :style="{ width }">
    <div class="row">
      <div class="col-12 col-sm-11" v-if="region">
        <h4 class="region-profile-card__title m-0">
          {{ translateRegion(region.region_id) }}
        </h4>
        <h3 class="region-profile-card__players mb-1" v-if="region && region.players">
          {{ region.players.length }} Power Players
        </h3>
        <h3 class="region-profile-card__name m-0" v-if="listCountries && listCountries.length > 0">
          from {{ listCountries.length }} {{ listCountries.length == 1 ? `country` : `countries` }}
        </h3>
        <div class="pt-3">
          <a class="btn btn-dark" target="_PARENT" :href="`https://icij.org/investigations/pandora-papers/power-players/?region=${region.region_id}`">{{ $t('providerProfile.readMore') }} <IconArrowRight /></a>
        </div>

        <div class="mt-4 pb-3 text-center">
          <CustomSharingOptions :title="`${$t('social.region')} ${translateRegion(region.region_id)}`" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CustomSharingOptions from '@/components/CustomSharingOptions'
import IconArrowRight from '@/components/IconArrowRight'
import utils from '@/mixins/utils'

export default {
  name: 'RegionProfileCard',
  mixins: [utils],
  props: {
    region: {
      type: Object
    },
    width: {
      type: String,
      default: '100%'
    },
    listCountries: {
      type: [Array]
    }
  },
  components: {
    IconArrowRight,
    CustomSharingOptions
  },
  data() {
    return {
      enableFooter: true
    }
  }
}
</script>

<style lang="scss">
  .region-profile-card {
    position: relative;
    top: 0;
    color: #fff;
    width: 100%;
    margin: 0 auto;
    padding: 14px 20px;

    &__player_image {
      position: relative;
      height: 280px;
      width: 260px;
      margin: 0 auto;
    }

    &__image {
      width: auto;
      height: 220px;
      background: var(--app-color-black);
      border-radius: 100%;
      overflow: hidden;
    }

    &__logo {
      position: absolute;
      width: 100%;
      max-width: 120px;
      bottom: 15px;
      left: 0;
    }

    &__players {
      display: inline-block;
      font-size: 21px;
      font-weight: 900;
      padding: 3px;
      color: var(--app-color-black);
    }

    &__name {
      display: inline-block;
      font-size: 18px;
      font-weight: 600;
      padding: 3px;
      color: var(--app-color-white);
      background: var(--app-color-red);
    }

    &__title {
      color: var(--app-color-black);
      font-size: 61px;
      font-weight: 900;
    }

    &__read-more, &__read-more:hover {
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>
